{
  "title": "Alerts",
  "orgIntro": "Alerts of every project you can see and the organisation's shared rules. Silences and channels belong to each project: they are under “This project”.",
  "projectIntro": "This project's alerts: what is happening now, the history, the rules, quiet during planned work, and where messages go.",
  "tabsLabel": "Alert sections",
  "tabs": {
    "active": "Active",
    "history": "History",
    "rules": "Rules",
    "silences": "Quiet",
    "channels": "Channels"
  },
  "scope": {
    "label": "Alert scope",
    "project": "This project",
    "organization": "Whole organisation"
  },
  "mine": "Notification settings",
  "wholeProject": "Whole project",
  "severity": { "warn": "Warning", "critical": "Critical" },
  "minSeverity": { "warn": "Warnings and critical", "critical": "Critical only" },
  "status": {
    "firing": "Active",
    "resolved": "Resolved",
    "oneOff": "Event",
    "mutedUntil": "Muted until {{time}}",
    "maintenance": "Maintenance",
    "muted": "Muted"
  },
  "kinds": {
    "agent_down": "Agent not reporting",
    "server_off": "Server not running",
    "cpu_high": "High CPU",
    "memory_high": "Low memory",
    "disk_high": "Disk full",
    "load_high": "High load",
    "disk_forecast": "Disk filling up",
    "container_down": "Container down",
    "service_down": "Service failed",
    "security_updates": "Security updates",
    "ssl_expiring": "Certificate expiring",
    "operation_failed": "Operation failed",
    "budget_threshold": "Budget threshold"
  },
  "text": {
    "agent_down": "The Autopilot agent is not reporting",
    "server_off": "The server is not running",
    "cpu_high": "CPU {{value}}\u00a0% (threshold {{threshold}}\u00a0%)",
    "memory_high": "Memory {{value}}\u00a0% (threshold {{threshold}}\u00a0%)",
    "disk_high": "Disk {{subject}}: {{value}}\u00a0% (threshold {{threshold}}\u00a0%)",
    "load_high": "Load {{value}} per core (threshold {{threshold}})",
    "disk_forecast": "Disk {{subject}} fills up in about {{value}}\u00a0h",
    "container_down": "Container {{subject}} is down",
    "service_down": "Service {{subject}} failed",
    "security_updates": "Security updates pending: {{value}}",
    "ssl_expiring": "Certificate {{subject}} expires in {{value}} days",
    "sslExpired": "Certificate {{subject}} has expired",
    "operation_failed": "Operation failed: {{subject}}",
    "budget_threshold": "Project spending reached {{subject}} of the budget"
  },
  "condition": {
    "percent": "above {{threshold}}\u00a0%",
    "per_core": "above {{threshold}} per core",
    "hours": "full within {{threshold}}\u00a0h",
    "days": "{{threshold}} days before the end",
    "count": "from {{threshold}}",
    "for": "for over {{minutes}}\u00a0min",
    "atOnce": "at once",
    "event": "on every event"
  },
  "source": {
    "default": "Default",
    "organization": "Organisation",
    "project": "Project",
    "server": "Server",
    "here": "Set here"
  },
  "columns": {
    "what": "What happened",
    "where": "Where",
    "started": "Started",
    "state": "State",
    "rule": "Rule",
    "condition": "Condition",
    "severity": "Severity",
    "source": "From"
  },
  "actions": {
    "mute": "Mute for 1\u00a0h",
    "muteServer": "Mute the server for 1\u00a0h",
    "unmute": "Lift",
    "edit": "Change",
    "loadMore": "Show more",
    "markRead": "Mark as read"
  },
  "toast": {
    "muted": "Muted until {{time}}",
    "muteFailed": "Could not mute",
    "new": "New alert",
    "several": "New alerts: {{n}}"
  },
  "empty": {
    "activeTitle": "All quiet",
    "active": "Nothing is firing. When a rule fires, the alert shows here and goes to everyone who follows it.",
    "historyTitle": "No alerts yet",
    "history": "Every alert will be here: when it started, when it ended and who was told. Kept for 90 days."
  },
  "rule": {
    "title": "Rule: {{name}}",
    "about": {
      "agent_down": "The Autopilot agent on the server stopped sending data.",
      "server_off": "The provider reports the server off or not answering. Servers switched off through the panel do not count.",
      "cpu_high": "CPU usage stays above the threshold.",
      "memory_high": "Used memory stays above the threshold.",
      "disk_high": "The root filesystem is filled above the threshold.",
      "load_high": "The one-minute load average per core is above the threshold.",
      "disk_forecast": "At the pace of the last day the disk fills up sooner than the given hours.",
      "container_down": "A Docker container stopped with an error, is restarting or unhealthy.",
      "service_down": "A systemd service failed.",
      "security_updates": "Security updates are pending on the server. The panel does not install them; the command is on the Autopilot tab.",
      "ssl_expiring": "A certificate of the project, or one Autopilot found on the server, ends sooner than the given days.",
      "operation_failed": "An operation of the panel (create, rebuild, change) ended in an error.",
      "budget_threshold": "The project's spending reached a threshold of its budget."
    },
    "reset": "Use the level above",
    "save": "Save",
    "enabled": "Rule is on",
    "threshold": {
      "percent": "Threshold, %",
      "per_core": "Threshold, load per core",
      "hours": "Fills up sooner than, hours",
      "days": "Expires sooner than, days",
      "count": "Updates, at least"
    },
    "duration": "For how many minutes in a row",
    "durationHint": "0 alerts at once.",
    "severity": "Severity",
    "above": "Level above ({{source}}): {{condition}}",
    "off": "Off",
    "cloudEvent": "Cloud event",
    "editLabel": "Change rule “{{name}}”"
  },
  "rules": {
    "orgTitle": "Default rules",
    "orgIntro": "They apply in every project of the organisation until a project or server sets its own.",
    "orgReadOnly": "They apply in every project until a project or a server sets its own. Organisation administrators change them; the project's own values are under “This project → Rules”.",
    "sharedRule": "Organisation-wide rule",
    "projectTitle": "Project rules",
    "projectIntro": "The project's own values over the organisation's rules. One server can refine them on its Alerts tab."
  },
  "channels": {
    "title": "Telegram bots",
    "intro": "Alerts arrive through these bots. The default bot serves every project until a project chooses another one.",
    "addBot": "Add a bot",
    "emptyTitle": "No bots yet",
    "empty": "Create a bot with @BotFather in Telegram and add it here by its token. Then everyone links their Telegram to it in the profile menu → Notification settings.",
    "default": "Default",
    "failing": "Not working",
    "failingHint": "Telegram does not accept this bot's token. Create a new token with @BotFather and add the bot again.",
    "token": "Token",
    "linkedLabel": "Linked",
    "linked": "people: {{people}}, chats: {{groups}}",
    "usedBy": "Projects",
    "usedByDefault": "all except those that chose another bot",
    "usedByNone": "none chose it",
    "test": "Test",
    "tested": "Test message sent: {{chat}}",
    "testFailed": "The test failed",
    "makeDefault": "Make default",
    "remove": "Remove",
    "removeTitle": "Remove bot @{{username}}?",
    "removeLinks": "Every chat of people and groups linked to it is unlinked.",
    "removeDefault": "The next bot, if any, becomes the default.",
    "removeProjects": "Projects that chose this bot switch to the default one.",
    "removeToken": "The bot's token is removed from the panel; the bot itself stays in Telegram.",
    "add": {
      "title": "Add a Telegram bot",
      "description": "Alerts will arrive from this bot.",
      "step1": "In Telegram, open @BotFather and send /newbot.",
      "step2": "Choose a name and a username: BotFather sends you a token.",
      "step3": "Paste the token here.",
      "token": "Bot token",
      "never": "We check the token with Telegram and store it encrypted. It is never shown again.",
      "submit": "Add",
      "done": "Bot @{{username}} added"
    }
  },
  "link": {
    "personTitle": "Link Telegram",
    "personDone": "Done: {{chat}} is linked",
    "personStep1": "Open the link on a phone or computer with Telegram and press Start.",
    "personStep2": "The bot answers that your account is linked; this page notices by itself.",
    "groupTitle": "Link a group chat",
    "groupStep1": "Open the link and choose the group chat to add the bot to.",
    "groupStep2": "Telegram adds the bot and hands it a one-time code.",
    "groupStep3": "The bot writes in the chat that the project's alerts will arrive there.",
    "open": "Open @{{bot}} in Telegram",
    "byHand": "If the link does not open, send @{{bot}} this command:",
    "commandLabel": "Linking command",
    "expires": "The link works once, until {{time}}.",
    "done": "Done"
  },
  "silences": {
    "mutesTitle": "Muted now",
    "mutesIntro": "While an alert is muted nobody is told about it. The history is kept anyway.",
    "mutesEmpty": "Nothing is muted.",
    "allAlerts": "All alerts",
    "until": "Until",
    "by": "By",
    "windowsTitle": "Maintenance windows",
    "windowsIntro": "Planned work: alerts of the project or one server reach nobody during it.",
    "windowsEmpty": "No maintenance windows planned.",
    "addWindow": "Plan a window",
    "when": "When",
    "reason": "Reason",
    "deleteWindow": "Delete the maintenance window",
    "window": {
      "title": "Maintenance window",
      "description": "No alerts are sent during it. Times are your local time.",
      "server": "Server",
      "starts": "Starts",
      "ends": "Ends",
      "reason": "Reason (optional)",
      "create": "Plan"
    }
  },
  "project": {
    "botTitle": "Project bot",
    "botIntro": "Which bot sends this project's alerts.",
    "noBots": "The organisation has no Telegram bots yet.",
    "addBot": "Add a bot",
    "bot": "Bot",
    "useDefault": "The organisation's default (@{{username}})",
    "sentBy": "This project's alerts come from @{{username}}.",
    "groupsTitle": "Group chats",
    "groupsIntro": "The project's alerts also go to these chats, such as the on-call chat.",
    "groupMin": "What to send",
    "linkGroup": "Link a group chat",
    "groupsEmpty": "No group chats. Link your team's chat and the bot will write there.",
    "groupsEmptyGuest": "No group chats.",
    "chat": "Chat",
    "linked": "Linked",
    "unlinkGroup": "Unlink"
  },
  "server": {
    "noAutopilot": "Autopilot is off on this server: only the “Server not running” rule and cloud events apply. Turn Autopilot on in its tab to watch memory, disks, services and containers.",
    "activeTitle": "Now",
    "activeIntro": "What is firing on this server.",
    "activeEmpty": "All is well on this server now.",
    "historyTitle": "Server history",
    "rulesTitle": "Server rules",
    "rulesIntro": "This server's own values over the project's rules."
  },
  "profile": {
    "title": "Notification settings",
    "intro": "Where and what to tell you: Telegram, projects and servers, severity, quiet hours.",
    "telegramTitle": "Telegram",
    "telegramIntro": "Link your Telegram to the organisation's bot and alerts arrive in your private messages.",
    "noBots": "The organisation has no Telegram bot yet. Ask an administrator to add one in API and integrations → Messengers.",
    "linkedAs": "Linked: {{chat}}",
    "notLinked": "Not linked",
    "link": "Link Telegram",
    "unlink": "Unlink",
    "whatTitle": "What to send",
    "whatIntro": "By default: everything you can see in the panel, from warnings up.",
    "projects": "Projects",
    "allProjects": "Every project I have access to",
    "chosenProjects": "Only the projects I choose",
    "serversOf": "Servers of the project",
    "allServers": "All servers",
    "chosenServers": "Only the servers I choose",
    "minSeverity": "Severity",
    "quietTitle": "Quiet hours",
    "quietOn": "No Telegram messages during quiet hours",
    "quietStart": "From",
    "quietEnd": "Until",
    "timeZone": "Time zone",
    "allowCritical": "Send critical alerts anyway",
    "whereTitle": "Where",
    "panel": "In the panel",
    "telegram": "In Telegram",
    "language": "Language of messages",
    "save": "Save",
    "saved": "Notification settings saved",
    "inboxTitle": "Latest notifications",
    "inboxIntro": "Alerts that reached you in the panel.",
    "inboxEmpty": "No notifications yet.",
    "unread": "Unread"
  }
}
